import { DateTime } from "luxon";
import TicketPrices from "src/utils/ticketPrices";

export default class StructuredData {
	constructor(event) {
		this.event = event;
	}

	asJSON() {
		return {
			"@context": "http://schema.org",
			"@type": "Event",
			name: this.event.title,
			url: this.event.url,
			description: this.event.description || "No description",
			startDate: this.event.datetime,
			endDate: this.getEndTime(),
			image: this.event.imageUrl,
			eventStatus: "EventScheduled",
			offers: this.getOffers(),
			organizer: this.getOrganizer(),
			performer: this.getPerformer(),
			eventAttendanceMode: "OfflineEventAttendanceMode",
			location: {
				"@type": "Place",
				name: this.event.venueName || "-",
				address: {
					"@type": "PostalAddress",
					streetAddress: this.event.data.address_1,
					addressLocality: this.event.data.town,
					postalCode: this.event.data.post_code,
					addressCountry: this.event.data.iso_country,
				},
			},
		};
	}

	getEndTime() {
		if (this.event.endTime) {
			return this.event.endTime;
		}

		if (!this.event.datetime) {
			return;
		}

		const time = DateTime.fromISO(this.event.datetime, { setZone: true });
		return time.plus({ hours: 1 }).toISODate();
	}

	getOrganizer() {
		return {
			"@type": "Organization",
			url: "https://www.evvnt.com/",
			name: this.event.organizerName || "Private",
		};
	}

	getPerformer() {
		return {
			"@type":
				this.event.data.artists && this.event.data.artists.length > 1
					? "PerformingGroup"
					: "Person",
			name: this.event.data.artists || "Not defined",
		};
	}

	getOffers() {
		if (!this.event.hasPrices) {
			return this.generateOffer("0.00", "USD");
		}

		const ticketPriceHelper = new TicketPrices(this.event.data.prices);
		const lowestPrice = ticketPriceHelper.orderedPrices()[0];
		const price = ticketPriceHelper.price_amount(lowestPrice);
		const currencyCode = lowestPrice.substring(0, 3);

		return this.generateOffer(price, currencyCode);
	}

	generateOffer(price, currencyCode) {
		return {
			"@type": "Offer",
			url: this.fetchOfferUrl(),
			price: price,
			priceCurrency: isNaN(currencyCode) ? currencyCode : null,
			validFrom: this.event.createdAt || this.event.datetime,
			availability: "https://schema.org/InStock",
		};
	}

	fetchOfferUrl() {
		if (this.event.isTicketmaster) {
			// For ticketmaster events, we always want to use our primary calendar
			// as the source of truth for the offers URL.
			return this.event.evvntHref;
		}

		return this.event.mainLink || this.event.absoluteHref;
	}
}
